import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Alert, Button, ConfigProvider, Form, Input, Typography, theme } from "antd";
import actions from "../../redux/admin/actions";
import BrandLogo from "../../../components/BrandLogo";
import Wrapper from "./index.style";

const BRAND = "#ffbf00";
const { signIn } = actions;

export class LoginPanel extends Component {
  handleFinish = ({ email, password }) => {
    this.props.signIn(email, password);
  };

  render() {
    const { t, authError, authSubmitting } = this.props;
    const error = authError === "ADMIN_REQUIRED" ? t("admin.nav.adminRequired") : authError;

    return (
      <ConfigProvider
        theme={{
          algorithm: theme.darkAlgorithm,
          token: {
            colorPrimary: BRAND,
            colorBgContainer: "#131313",
            colorBorder: "#292929",
            borderRadius: 7,
          },
          components: {
            Button: { primaryColor: "#050505", fontWeight: 700 },
          },
        }}
      >
        <Wrapper>
          <div className="login-card">
            <div className="brand-row">
              <BrandLogo alt={t("admin.common.brand")} className="brand-logo" />
            </div>
            <Typography.Title level={4} className="login-title">
              {t("admin.auth.welcome")}
            </Typography.Title>
            <Typography.Paragraph className="login-description">
              {t("admin.auth.description")}
            </Typography.Paragraph>
            {error && <Alert type="error" message={error} className="login-error" />}
            <Form layout="vertical" onFinish={this.handleFinish} requiredMark={false}>
              <Form.Item
                label={<span className="field-label">{t("admin.auth.email")}</span>}
                name="email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input autoFocus size="large" data-testid="admin-email" />
              </Form.Item>
              <Form.Item
                label={<span className="field-label">{t("admin.auth.password")}</span>}
                name="password"
                rules={[{ required: true }]}
              >
                <Input.Password size="large" data-testid="admin-password" />
              </Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={authSubmitting}
                data-testid="admin-submit"
              >
                {t("admin.auth.signIn")}
              </Button>
            </Form>
            <Typography.Paragraph className="login-restriction">
              {t("admin.auth.restricted")}
            </Typography.Paragraph>
          </div>
        </Wrapper>
      </ConfigProvider>
    );
  }
}

LoginPanel.propTypes = {
  signIn: PropTypes.func.isRequired,
  authError: PropTypes.string,
  authSubmitting: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

LoginPanel.defaultProps = {
  authError: null,
};

const mapStateToProps = ({ Admin }) => ({
  authError: Admin.authError,
  authSubmitting: Admin.authSubmitting,
});

const mapDispatchToProps = (dispatch) => ({
  signIn: (email, password) => dispatch(signIn(email, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withTranslation("common")(LoginPanel),
);
